import { CoreButtonNextProps as ButtonNextProps } from '../internal/WixUiCoreComponents/components/CoreButtonNext/CoreButtonNext';
import { TPAComponentProps } from '../../types';
import { HoverStyles } from '../Button';

export enum TextButtonPriority {
  primary = 'primary',
  secondary = 'secondary',
  link = 'link',
  primaryLink = 'primaryLink',
}

export interface TextButtonProps extends ButtonNextProps, TPAComponentProps {
  priority?: TextButtonPriority;
  hoverStyle?: HoverStyles;
}
